import React, { useEffect, useState } from "react";

import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Input from "@mui/material/Input";
import Typography from "@mui/material/Typography";

import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import { getFinalKeySegment, snakeToTitle } from "../utils";
// import { FormControl } from '@mui/material';

let columnOptions = [];

const SearchCriteria = ({ searchColumns, onSearch, searchConfig, data }) => {
  // Transform the available columns into options for react-select
  if (columnOptions.length === 0 && searchColumns) {
    columnOptions = searchColumns.map((col) => ({
      value: col,
      label: snakeToTitle(getFinalKeySegment(col)),
    }));
  }

  //const [queryParams, setQueryParams] = useState({});
  const [selectedCategory, setSelectedCategory] = useState("adsorbed_state");
  const [searchFilters, setSearchFilters] = useState([
    { column: "", searchText: "" },
  ]);
  const [autocompletes, setAutocompletes] = useState([[]]);

  const handleColumnChange = (index, col) => {
    const newFilters = [...searchFilters];
    newFilters[index].column = col;
    setSearchFilters(newFilters);

    const newAutocompletes = [...autocompletes];
    const finalCol = getFinalKeySegment(col);
    const auto = data
      .map((item) => String(item[getFinalKeySegment(finalCol)]))
      .filter(
        (item) =>
          item !== null &&
          item !== undefined &&
          item !== "null" &&
          item !== "undefined",
      );
    newAutocompletes[index] = Array.from(new Set(auto)).sort();
    setAutocompletes(newAutocompletes);
    if (data.length == 0) {
      let templateData = [
        {
          applied_potential: "-0.5",
          adsorption_energy: 1.903,
          net_charge_state: 0,
          adsorbate_formula: "C1O2H1",
          catalyst_elements: "Ag",
        },
        {
          applied_potential: "-0.25",
          adsorption_energy: 2.879,
          net_charge_state: 0,
          adsorbate_formula: "C1O1",
          catalyst_elements: "Pt",
        },
        {
          applied_potential: "-1",
          adsorption_energy: 0.966,
          net_charge_state: 0,
          adsorbate_formula: "C1O2H1",
          catalyst_elements: "Co",
          catalyst_facet: "111",
        },
        {
          applied_potential: 0,
          adsorption_energy: -0.353,
          net_charge_state: 0.394,
          adsorbate_formula: "N2",
          catalyst_elements: "Au",
          catalyst_facet: "110",
        },
        {
          applied_potential: -0.25,
          adsorption_energy: -1.365,
          net_charge_state: 0.379,
          adsorbate_formula: "N2H2",
          catalyst_elements: "Co",
          catalyst_facet: "211",
        },
        {
          applied_potential: 1.23,
          adsorption_energy: -1.365,
          net_charge_state: 0.379,
          adsorbate_formula: "N2H2",
          catalyst_elements: "C",
          catalyst_facet: "100",
        },
        {
          applied_potential: 0.83,
          adsorption_energy: -1.365,
          net_charge_state: 0.379,
          adsorbate_formula: "N2H2",
          catalyst_elements: "Ni",
          catalyst_facet: "100",
        },
        {
          applied_potential: 0.83,
          adsorption_energy: -1.365,
          net_charge_state: 0.379,
          adsorbate_formula: "N2H2",
          catalyst_elements: "O",
          catalyst_facet: "011",
        },
      ];
      const newAutocompletes = [...autocompletes];
      const finalCol = getFinalKeySegment(col);
      const auto = templateData
        .map((item) => String(item[getFinalKeySegment(finalCol)]))
        .filter(
          (item) =>
            item !== null &&
            item !== undefined &&
            item !== "null" &&
            item !== "undefined",
        );
      newAutocompletes[index] = Array.from(new Set(auto)).sort();
      setAutocompletes(newAutocompletes);
    }
  };

  const handleSearchTextChange = (index, searchText) => {
    const newFilters = [...searchFilters];
    newFilters[index].searchText = searchText;
    setSearchFilters(newFilters);

    // if autocomplete is empty, then we need to update the autocomplete options
    if (autocompletes[index].length === 0) {
      const newAutocompletes = [...autocompletes];
      const finalCol = getFinalKeySegment(searchFilters[index].column);
      const auto = data
        .map((item) => String(item[getFinalKeySegment(finalCol)]))
        .filter(
          (item) =>
            item !== null &&
            item !== undefined &&
            item !== "null" &&
            item !== "undefined",
        );
      newAutocompletes[index] = Array.from(new Set(auto)).sort();
      setAutocompletes(newAutocompletes);
    }
  };

  const handleAddFilter = () => {
    setSearchFilters([...searchFilters, { column: "", searchText: "" }]);
    setAutocompletes([...autocompletes, []]);
  };

  useEffect(() => {
    setSearchFilters([
      {
        column: "adsorbed_state.catalyst_elements",
        searchText: "",
      },
    ]);
    setAutocompletes([...autocompletes, []]);
    handleColumnChange(0, "adsorbed_state.catalyst_elements");
  }, []);

  const handleRemoveFilter = (index) => {
    const newFilters = [...searchFilters];
    newFilters.splice(index, 1);
    setSearchFilters(newFilters);

    const newAutocompletes = [...autocompletes];
    newAutocompletes.splice(index, 1);
    setAutocompletes(newAutocompletes);
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setAutocompletes([{ column: "", searchText: "" }]);
    setSearchFilters([[]]);
    //setQueryParams({}); // Clear existing query parameters
  };

  const handleSearch = () => {
    if (!selectedCategory) {
      alert("Please select a query type.");
      return;
    }
    let queryParams = {};
    searchFilters.forEach((filter) => {
      if (filter.column && filter.searchText) {
        queryParams[filter.column] = filter.searchText;
      }
    });

    onSearch({ ...queryParams, query: selectedCategory });
  };

  // Disallow searching by catalyst formula or unique id
  let exclusions = ["adsorbed_state.catalyst_formula", "unique_id"];
  searchConfig.adsorbed_state = searchConfig.adsorbed_state.filter(
    (field) => !exclusions.includes(field),
  );

  return (
    <div style={{ textAlign: "left" }}>
      <Typography
        style={{ paddingLeft: "5px" }}
        variant="subtitle1"
        component="p"
      >
        Select Search Criteria:
      </Typography>
      {selectedCategory &&
        searchFilters.map((filter, index) => (
          <div key={index} style={{ display: "flex", alignItems: "center" }}>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }}>
              <Select
                value={filter.column}
                onChange={(e) => handleColumnChange(index, e.target.value)}
                //options={columnOptions}
                placeholder="Select Column"
              >
                {searchConfig[selectedCategory].map((key) => (
                  <MenuItem value={key}>
                    {snakeToTitle(getFinalKeySegment(key))}
                  </MenuItem>
                ))}
                {/* {columnOptions.map((column) => (
                                <MenuItem value={column.value}>
                                    {column.label}
                                </MenuItem>
                            ))} */}
              </Select>
            </FormControl>
            {/* <Input
                        type="text"
                        variant="standard"
                        sx={{ m: 1, minWidth: 200 }}
                        value={filter.searchText}
                        onChange={(e) => handleSearchTextChange(index, e.target.value)}
                        placeholder="Search Text"
                    /> */}
            <Autocomplete
              id="free-solo-search-text"
              freeSolo
              disableClearable
              options={autocompletes[index]}
              onChange={(e, v) => handleSearchTextChange(index, v)}
              disabled={filter.column === ""}
              renderInput={(params) => {
								params.inputProps.value = filter.searchText;
                return <TextField
                  {...params}
									id={"searchField"+index}
                  variant="standard"
                  onChange={(e) =>
                    handleSearchTextChange(index, e.target.value)
                  }
                  sx={{ m: 1, width: 300 }}
                  label="Search Text"
                  InputProps={{
                    ...params.InputProps,
                    type: "search",
                  }}
                />
              }}
            />
            <Button
              variant="contained"
              onClick={() => handleRemoveFilter(index)}
            >
              Remove
            </Button>
          </div>
        ))}
      <Button variant="contained" sx={{ m: 1 }} onClick={handleAddFilter}>
        Add Search Criteria
      </Button>
      <Button variant="contained" sx={{ m: 1 }} onClick={handleSearch}>
        Search
      </Button>
    </div>
  );
};

export default SearchCriteria;
